module.exports = __webpack_public_path__ + "img/avatar4.828e0c00.png";